import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createBlock(_component_checkbox_field, _mergeProps({ ..._ctx.$attrs, ..._ctx.$props }, {
    "model-value": $options.proxyValue,
    "onUpdate:modelValue": $options.handleInput
  }), _createSlots({
    "additional-content": _withCtx(() => [
      _renderSlot(_ctx.$slots, "additional-content")
    ]),
    label: _withCtx(() => [
      _renderSlot(_ctx.$slots, "label")
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots['field-description'])
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "field-description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["model-value", "onUpdate:modelValue"]))
}